import Card from './Card';

export type { CardProps } from './Card';
export type { CardBodyProps } from './CardBody';
export type { CardHeaderProps } from './CardHeader';
export type { CardFooterProps } from './CardFooter';
export default Card;
